import { CustomLocale } from "flatpickr/dist/types/locale";
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/ja";
import "dayjs/locale/pt";
import "dayjs/locale/zh";
import { German } from "flatpickr/dist/l10n/de.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";

import { normalizeLocale } from "@/utils/locale";

import { DateType } from "./types";
import { LanguageCode } from "@/types/languages";

export const formatDate = (
  type: DateType,
  selectedDate: Date,
  format: string,
  dates: Date[],
  locale?: LanguageCode
) => {
  if (!dates || dates.length === 0) return "";
  const dayjsLocale = locale ? normalizeLocale(locale) : "en";

  switch (type) {
    case "multiple":
    case "single": {
      const formattedDate = dayjs(selectedDate).locale(dayjsLocale).format(format);
      return formattedDate;
    }
    case "range": {
      const initFormattedDate = dayjs(dates[0]).locale(dayjsLocale).format(format);
      const endFormattedDate = dayjs(dates[1]).locale(dayjsLocale).format(format);

      const formattedDate = dates[1]
        ? `${initFormattedDate} - ${endFormattedDate}`
        : initFormattedDate;

      return formattedDate;
    }
  }
};

const flatpickrLocales: Partial<Record<LanguageCode, CustomLocale>> = {
  "de-DE": German,
  "es-ES": Spanish,
  "fr-FR": French,
  "it-IT": Italian,
  "ja-JP": Japanese,
  "ko-KR": Korean,
  "pt-BR": Portuguese,
  "zh-TW": Mandarin,
};

export const getFlatpickrLocale = (locale: LanguageCode | undefined) => {
  return locale ? flatpickrLocales[locale] : undefined;
};
